const DEFAULT_COUNTRY_CODE: string = 'CA'

const findCountryCode = (address): string => {
  const country = address.address_components.find(c => c.types.includes('country'))
  return country ? country.short_name : DEFAULT_COUNTRY_CODE
}

const findCityName = (address): string => {
  const location =
    address.address_components.find(c => c.types.includes('locality')) || // city
    address.address_components.find(c => c.types.includes('postal_town')) || // city
    address.address_components.find(c => c.types.includes('administrative_area_level_3')) || // city or region
    address.address_components.find(c => c.types.includes('administrative_area_level_2')) || // region
    address.address_components.find(c => c.types.includes('country')) // country

  return location.long_name
}

export const fetchAddress = (
  lat: number,
  lon: number,
  successCallback: (address: { cityName: string, countryCode: string }) => void,
  failCallback?: (error: string) => void,
): void => {
  if (typeof google === 'undefined') {
    if (failCallback) failCallback('Google Maps is not loaded for geocoding')
    return
  }
  const geocoder = new google.maps.Geocoder()
  geocoder.geocode({ location: { lat, lng: lon } }, (results, status) => {
    if (status === 'OK' && results.length > 0) {
      const address = {
        cityName: findCityName(results[0]),
        countryCode: findCountryCode(results[0]),
      }
      successCallback(address)
    } else if (failCallback) {
      failCallback(`Geocoing for lat: ${lat}, lon: ${lon} failed`)
    }
  })
}
